import APIClient from '@/shared/http/clients/api'

const resourceName = 'parametros/card-visita'
const APICore = process.env.APIBaseURLCore

const Get = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/`, data, config)

const ParametroAberturaCardsVisitaRepository = {
  Get,
  Create,
  Update
}

export default ParametroAberturaCardsVisitaRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/parametroAberturaCardsVisita.js